import React from 'react';
import PropTypes from 'prop-types';

import SecondaryHeader from '../shared/SecondaryHeader';

import StudentDashboardProvider from './StudentDashboard.context';

import '../classrooms.scss';

const Classrooms = ({children, location, ...rest}) => {
  return (
    <StudentDashboardProvider location={location} {...rest}>
      <SecondaryHeader location={location} {...rest} />
      <div className='classrooms'>{children && React.cloneElement(children, {})}</div>
    </StudentDashboardProvider>
  );
};

Classrooms.propTypes = {
  children: PropTypes.node,
  location: PropTypes.object
};

export default Classrooms;
